import { render } from "./PreferredLocumConfirm.vue?vue&type=template&id=745691d4"
import script from "./PreferredLocumConfirm.vue?vue&type=script&lang=js"
export * from "./PreferredLocumConfirm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__